export default [
  {
    path: '/khmer-secondary-schedules',
    name: 'khmer-secondary-schedule',
    meta: { requiresAuth: true },
    component: () => import('@/pages/khmer-secondary-schedule/index.vue')
  }
]
